import secureLocalStorage from "react-secure-storage";

import { GET_USER_PROFILE, LOGOUT_USER } from "helpers/constants";
import { findInObjectArrayByMatchingProperties } from "helpers/functions";

import * as api from "middlewares/apis";
import dexieDB from "database/dexieDB";

export const getUserByToken = async (token) => {
	// try {
	// 	// const token = secureLocalStorage.getItem("token");
	// 	const { data } = await api.getUserByUsername(token);
	// 	if (data) return data;
	// 	// if (data) secureLocalStorage.setItem("profile", data);
	// 	// dispatch({
	// 	// 	type: GET_USER_PROFILE,
	// 	// });
	// } catch (error) {
	// 	console.error(error);
	// }
};

export const getUserProfile = () => async (dispatch) => {
	const currentUser = secureLocalStorage.getItem("currentUser");

	try {
		if (currentUser?.loginType === "daffi") {
			// const daffiUsers = secureLocalStorage.getItem("daffiUsers");
			// let daffiUser = await findInObjectArrayByMatchingProperties(daffiUsers, {
			// 	_id: currentUser?._id,
			// });
			// daffiUser = daffiUser[0];
			// dispatch({
			// 	type: GET_USER_PROFILE,
			// 	payload: daffiUser,
			// });
		} else if (currentUser?.loginType === "local") {
			const userData = await dexieDB.localUsers
				.filter((item) => item?.data?._id === currentUser?._id)
				.first()
				.then((data) => {
					if (data?.data) {
						return data.data;
					} else return null;
				});

			dispatch({
				type: GET_USER_PROFILE,
				payload: userData,
			});
		}
	} catch (error) {
		console.error(error);
	}
};

export const updateProfileInfoByID = (formData, notify) => async (dispatch) => {
	const currentUser = secureLocalStorage.getItem("currentUser");

	try {
		if (currentUser?.loginType === "daffi") {
			// dispatch(buildingComponent(true));
			// const token = secureLocalStorage.getItem("token");
			// const { data } = await api.updateProfileInfoByID(formData, token);
			// if (data && data["data"]) {
			// 	alert(data["message"]);
			// 	secureLocalStorage.setItem("profile", data["data"]);
			// } else {
			// 	alert(data["message"]);
			// }
			// dispatch({ type: GET_USER_PROFILE });
			// dispatch(buildingComponent(false));
		} else if (currentUser?.loginType === "local") {
			const userData = await dexieDB.localUsers
				.filter((item) => item?.data?._id === currentUser?._id)
				.first()
				.then((data) => {
					if (data) {
						return data;
					} else return null;
				});

			if (userData?.data) {
				await dexieDB.localUsers.update(userData.id, { data: formData }).then((updateCount) => {
					if (!updateCount) notify("error", "Profile info update failed");
					// else notify("success", "Profile info updated");
				});
			} else {
				notify("error", "There is no profile found in local users");
			}
		}

		dispatch(getUserProfile());
	} catch (error) {
		console.error(error);
	}
};

export const deleteUserProfileFromUsers = (formData, navigatePage, notify) => async (dispatch) => {
	const currentUser = secureLocalStorage.getItem("currentUser");

	try {
		if (currentUser?.loginType === "daffi") {
			// await api.deleteAccountFromUserProfile(formData, currentUser["access-token"]).then(async ({ data }) => {
			// 	if (data && data["error"]) {
			// 		alert(data["message"]);
			// 	} else if (data && data["data"]) {
			// 		let userAccounts = secureLocalStorage.getItem(currentUser?._id + "-T-Accounts");
			// 		if (userAccounts && userAccounts["accounts"] && userAccounts["accounts"].length > 0) {
			// 			await removeItemFromObjectArrayByMatchingProperties(userAccounts["accounts"], formData);
			// 			secureLocalStorage.setItem(currentUser?._id + "-T-Accounts", data["data"]);
			// 			dispatch({
			// 				type: GET_ALL_ACCOUNTS_OF_USER,
			// 				payload: data["data"]["accounts"],
			// 			});
			// 		} else {
			// 			alert("No accounts found in local database");
			// 		}
			// 		alert(data["message"]);
			// 	}
			// });
		} else if (currentUser?.loginType === "local") {
			const userData = await dexieDB.localUsers
				.filter((item) => item?.data?._id === currentUser?._id)
				.first()
				.then((data) => {
					if (data) {
						return data;
					} else return null;
				});

			if (userData?.data) {
				dexieDB.localUsers
					.delete(userData.id)
					.then(() => {
						notify("success", "Profile deleted");

						navigatePage("/");

						dispatch({
							type: LOGOUT_USER,
						});
					})
					.catch((error) => notify("error", "Profile deletion failed"));
			} else {
				notify("error", "There is no profile found in local users");
			}
		}
	} catch (error) {
		console.error(error);
	}
};
